import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminApi } from '@formosa/shared/api/admin';
import { useAuth } from '../../auth/AuthContext';
import { useVersionInfo } from '../../hooks/useVersionInfo';

export default function TopBar() {
  const { user, role, logout } = useAuth();
  const versionText = useVersionInfo();
  const [serverTime, setServerTime] = useState(() => new Date());
  const [pendingOfflineDeposit, setPendingOfflineDeposit] = useState(0);
  const [pendingOnlineDeposit, setPendingOnlineDeposit] = useState(0);
  const [pendingWithdraw, setPendingWithdraw] = useState(0);
  const [fullscreen, setFullscreen] = useState(false);

  const roleName = role?.role || role?.description || '管理員';

  useEffect(() => {
    const timer = setInterval(() => setServerTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function loadPending() {
      try {
        const [depositCounts, withdraw] = await Promise.all([
          adminApi.pendingDepositCounts(),
          adminApi.pendingWithdrawCount(),
        ]);
        if (!cancelled) {
          setPendingOfflineDeposit(depositCounts?.offline ?? 0);
          setPendingOnlineDeposit(depositCounts?.online ?? 0);
          setPendingWithdraw(withdraw);
        }
      } catch {
        /* 待辦載入失敗不阻斷頁面 */
      }
    }

    loadPending();
    const poll = setInterval(loadPending, 60000);
    return () => {
      cancelled = true;
      clearInterval(poll);
    };
  }, []);

  function formatServerTime(date) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  async function toggleFullscreen() {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
        setFullscreen(true);
      } else {
        await document.exitFullscreen();
        setFullscreen(false);
      }
    } catch {
      /* 瀏覽器不支援全屏 */
    }
  }

  return (
    <header className="admin-topbar">
      <div className="admin-topbar-row">
        <div className="admin-topbar-alerts">
          {pendingOfflineDeposit > 0 && (
            <Link
              to="/system/capital-flow/recharge-list"
              className="admin-alert admin-alert-danger"
            >
              您有 <strong>{pendingOfflineDeposit}</strong> 筆未處理線下充值審核單！重要！
            </Link>
          )}
          {pendingOnlineDeposit > 0 && (
            <Link
              to="/system/capital-flow/online-recharge-list"
              className="admin-alert admin-alert-danger"
            >
              您有 <strong>{pendingOnlineDeposit}</strong> 筆未處理線上充值審核單！重要！
            </Link>
          )}
          {pendingWithdraw > 0 && (
            <Link
              to="/system/capital-flow/withdrawal-list"
              className="admin-alert admin-alert-info"
            >
              提示－您有 <strong>{pendingWithdraw}</strong> 筆未處理提現單！立即查看！！
            </Link>
          )}
        </div>

        {/* 右側由右至左：登出、改密、提示、全屏、歡迎 */}
        <div className="admin-topbar-actions">
          <span className="admin-welcome">
            {user?.username || '管理員'}【{roleName}】，歡迎您！
          </span>
          <button type="button" className="admin-topbar-btn" onClick={toggleFullscreen}>
            {fullscreen ? '退出全屏' : '全屏'}
          </button>
          <button type="button" className="admin-topbar-btn" disabled title="即將推出">
            提示設置
          </button>
          <button type="button" className="admin-topbar-btn" disabled title="即將推出">
            修改密碼
          </button>
          <button type="button" className="admin-topbar-btn" onClick={logout}>
            退出登入
          </button>
        </div>
      </div>

      <div className="admin-topbar-meta">
        <span>伺服器時間：{formatServerTime(serverTime)}</span>
        <span>版本號：{versionText}</span>
      </div>
    </header>
  );
}
